import { Box, Flex, Tooltip, styled } from "@100mslive/react-ui";
import { Fragment, useContext, useEffect } from "react";
import {
  selectIsAllowedToPublish,
  useHMSStore,
  useScreenShare,
} from "@100mslive/react-sdk";
import {
  useResetEmbedConfig,
  useResetPDFConfig,
  useUISettings,
} from "./AppData/useUISettings";

import IconButton from "../IconButton";
import { LiveHodoContext } from "../contexts/LiveHodoContext";
import { ShareScreenIcon } from "@100mslive/react-icons";
import { ShareScreenOptions } from "./pdfAnnotator/shareScreenOptions";
import { UI_SETTINGS } from "../common/constants";
import { isScreenshareSupported } from "../common/utils";
import { useTranslation } from "react-i18next";

export const ScreenshareToggle = ({ css = {} }) => {
  // const {
  //   stateCtx: { isScreenShareDisabled },
  //   setIsAudioShareDisabled,
  // } = useContext(LiveHodoContext);

  const isAllowedToPublish = useHMSStore(selectIsAllowedToPublish);
  const isAudioOnly = useUISettings(UI_SETTINGS.isAudioOnly);

  const {
    amIScreenSharing,
    screenShareVideoTrackId: video,
    toggleScreenShare,
  } = useScreenShare();
  const resetConfig = useResetPDFConfig();
  const embedResetConfig = useResetEmbedConfig();

  const isVideoScreenshare = amIScreenSharing && !!video;
  const { t } = useTranslation();

  // useEffect(() => {
  //   setIsAudioShareDisabled(isVideoScreenshare);
  // }, [isVideoScreenshare]);

  // useEffect(() => {
  //   console.log(isScreenShareDisabled);
  // }, [isScreenShareDisabled]);

  if (!isAllowedToPublish.screen || !isScreenshareSupported()) {
    return null;
  }

  return (
    <Fragment>
      <Flex direction="row">
        <ScreenShareButton
          variant="standard"
          key="ShareScreen"
          active={!isVideoScreenshare}
          css={css}
          disabled={isAudioOnly}
          onClick={async () => {
            await toggleScreenShare();
            resetConfig();
            embedResetConfig();
          }}
        >
          <Tooltip
            title={
              t("fm_toggle_sharescreen", {
                text: !isVideoScreenshare ? t("fm_start") : t("fm_stop")
              })
            }
          >
            <Box>
              <ShareScreenIcon />
            </Box>
          </Tooltip>
        </ScreenShareButton>
        {/* <ShareScreenOptions /> */}
      </Flex>
    </Fragment>
  );
};

const ScreenShareButton = styled(IconButton, {
  h: "$14",
  px: "$8",
  r: "$1",
  borderRadius: "$1",
  // borderTopRightRadius: 0,
  // borderBottomRightRadius: 0,
  "@md": {
    px: "$4",
    mx: 0,
  },
});

export const ShareMenuIcon = styled(ScreenShareButton, {
  // borderRadius: "$1",
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderTopRightRadius: "$1",
  borderBottomRightRadius: "$1",
  borderLeftWidth: 0,
  w: "$4",
  "@md": {
    px: "$2",
  },
});
